<ul class="nav nav-tabs mb-3">
  <li class="nav-item">
    <a
      routerLink="/billing"
      routerLinkActive="active"
      class="nav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      >Product Billing</a
    >
  </li>
  <li class="nav-item">
    <a
      routerLink="/services-billing"
      routerLinkActive="active"
      class="nav-link"
      [routerLinkActiveOptions]="{ exact: true }"
      >Services Billing</a
    >
  </li>
</ul>

<div class="content-info pr-0 service-billing" style="position: sticky">
  <div class="content-title d-flex justify-content-between">
    <h3 class="title mb-0">Service Billing</h3>
  </div>

  <div class="content-title">
    <div class="products-list-wrap">
      <div class="products-list">
        <div class="form-group product-search mb-3">
          <input
            type="text"
            [(ngModel)]="serviceSearchTerm"
            (input)="onServiceSearch()"
            placeholder="Search services..."
            class="form-control"
          />
        </div>

        @if (allServices?.length) {
          <ul>
            @for (service of allServices; track trackService($index, service)) {
              <li class="product">
                <figure>
                  <img src="images/icons/placeholder.png" alt="Service Image" />
                </figure>
                <div class="productname">
                  <h4>{{ service.name }}</h4>
                  <div class="prodcutprice">
                    @if (service.price) {
                      <h5>
                        <span><em>Rs</em></span>
                        {{ service.price | number: "1.2-2" }}
                      </h5>
                    }
                    <button (click)="addServiceToCart(service)">
                      Add to bill
                    </button>
                  </div>
                </div>
              </li>
            }
          </ul>
        } @else {
          <div class="text-center text-muted py-3">No services available.</div>
        }
      </div>
      <div class="draft-curtain mt-3 mb-3">
        <div
          class="offcanvas offcanvas-end"
          tabindex="-1"
          id="draftCurtain"
          aria-labelledby="draftCurtainLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="draftCurtainLabel">
              <i class="bi bi-journal-text"></i> Draft Bills
            </h5>
            <button
              type="button"
              class="btn-close text-reset"
              data-bs-dismiss="offcanvas"
            ></button>
          </div>
          <div class="offcanvas-body">
            @if (drafts.length) {
              <div>
                @for (draft of reversedDrafts; track draft; let i = $index) {
                  <div class="mb-3 p-2 border shadow-sm">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <strong>Draft {{ i + 1 }}</strong
                        ><br />
                        <small>{{ draft.timestamp | date: "shortTime" }}</small>
                      </div>
                      <div>
                        <span class="me-2">₹{{ draft.total?.grandTotal }}</span>
                        <button
                          class="btn btn-sm btn-primary"
                          (click)="resumeDraft(i)"
                          data-bs-dismiss="offcanvas"
                        >
                          Resume
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <p class="text-muted text-center">No saved drafts.</p>
            }
          </div>
        </div>

        @if (drafts.length) {
          <button
            class="draft-chevron-btn position-fixed end-0 top-50 translate-middle-y"
            data-bs-toggle="offcanvas"
            data-bs-target="#draftCurtain"
            style="
              color: green;
              padding: 10px 20px;
              border-radius: 8px 0 0 8px;
              border-color: white;
              z-index: 1050;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
              background-color: #f8f9fa;
              border: 1px solid #dee2e6;
              padding: 0.75rem 1rem;
              box-shadow: -2px 2px 8px rgba(0, 0, 0, 0.1);
            "
          >
            <i
              class="bi"
              [ngClass]="
                isDraftOpen
                  ? 'bi-chevron-double-right'
                  : 'bi-chevron-double-left'
              "
            ></i>
          </button>
        }
      </div>

      <div class="products-cart">
        <div class="cart-header">
          <div
            class="cart-title d-flex align-items-center justify-content-between"
          >
            <h4 class="mb-0 d-flex align-items-center">
              Services Cart
              <i class="bi bi-cart-check ms-2"></i>
            </h4>
            <div class="d-flex align-items-center">
              <button
                class="btn text-white p-1 ms-1"
                data-bs-toggle="modal"
                data-bs-target="#customerDetailsModal"
                style="background-color: var(--primary-color)"
              >
                Add Customer Details
              </button>

              <button
                class="btn text-white p-1 ms-2"
                (click)="openServiceOwnerModal()"
                style="background-color: var(--primary-color)"
              >
                Add Service Owner
              </button>
            </div>
          </div>
        </div>

        @if (selectedCustomer) {
          <div class="customer-info-row mb-3 d-flex align-items-center">
            <span class="fw-semibold me-2">Customer Name :</span>
            <i class="bi bi-person-circle me-2"></i>
            <span class="fw-semibold me-2">{{ selectedCustomer.name }}</span>
          </div>
        }
        @if (selectedProvider) {
          <div class="provider-info-row mb-3 d-flex align-items-center">
            <span class="fw-semibold me-2 text-dark">Service Owner :</span>
            <i class="bi bi-person-badge-fill me-2 text-dark"></i>
            <span class="fw-semibold me-2 text-dark">{{
              selectedProvider.name
            }}</span>
          </div>
        }

        <div class="cart-search">
          <div class="form-group">
            <input
              #manualServiceInput
              autofocus
              type="text"
              placeholder="Add manual service item..."
              [(ngModel)]="manualServiceName"
              (keydown.enter)="onManualServiceEnter()"
              class="form-control"
            />
          </div>
          <div class="search-btns">
            <button class="btn btnprimary" (click)="onManualServiceEnter()">
              Add Item
            </button>
            <button class="btn btnsecondary" (click)="clearServiceCart()">
              Clear Cart
            </button>
          </div>
        </div>

        @if (serviceCart.length > 0) {
          <div class="common-table">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Rate</th>
                    <th>Total (Net)</th>
                    <th><abbr title="Goods and Services Tax">GST</abbr> %</th>
                    <th>
                      <abbr title="Goods and Services Tax Amount">GST Amt</abbr>
                    </th>
                    <th>Grand Total</th>
                    @if (isAdminOrStoreManager()) {
                      <th>Delete</th>
                    }
                  </tr>
                </thead>

                <tbody>
                  @for (
                    item of serviceCart;
                    track trackService(i, item);
                    let i = $index
                  ) {
                    <tr>
                      <td>{{ item.name }}</td>
                      <td>
                        <input
                          type="number"
                          [(ngModel)]="item.price"
                          (ngModelChange)="calculateServiceTotals()"
                          class="form-control form-control-sm"
                          style="width: 100px"
                          readonly
                        />
                      </td>
                      <td>{{ item.totalAmount | number: "1.2-2" }}</td>
                      <td>
                        <span class="badge bg-secondary"
                          >{{ item.gstRate }}%</span
                        >
                      </td>
                      <td>{{ item.gstAmount | number: "1.2-2" }}</td>
                      <td>
                        <strong>{{ item.grandTotal | number: "1.2-2" }}</strong>
                      </td>

                      @if (isAdminOrStoreManager()) {
                        <td>
                          <button
                            type="button"
                            class="btn btn-trash"
                            (click)="removeService(i)"
                          >
                            <i class="bi bi-trash3"></i>
                          </button>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <div class="cart-price">
              <ul>
                <li>
                  <span>Sub Total (Gross Price)</span>
                  <span>{{
                    serviceGrandTotal.subTotal
                      | currency: "INR" : "symbol" : "1.2-2"
                  }}</span>
                </li>
                <li>
                  <span>Discount</span>
                  <div class="d-flex justify-content-end align-items-center">
                    <div
                      class="input-group input-group-sm"
                      style="width: 140px"
                    >
                      <input
                        type="number"
                        class="form-control text-end"
                        [(ngModel)]="manualDiscountValue"
                        (ngModelChange)="calculateServiceTotals()"
                        placeholder="0"
                        min="0"
                        [max]="
                          discountMode === 'PERCENTAGE'
                            ? 100
                            : serviceGrandTotal.finalTotal
                        "
                      />
                      <select
                        class="form-select flex-grow-0 ps-2 pe-1"
                        style="width: 55px; background-color: #f8f9fa"
                        [(ngModel)]="discountMode"
                        (change)="calculateServiceTotals()"
                      >
                        <option value="PERCENTAGE">%</option>
                        <option value="AMOUNT">₹</option>
                      </select>
                    </div>
                  </div>
                </li>

                @if (discountMode === "AMOUNT" && discountPercentage > 0) {
                  <li class="border-0 pt-0 pb-1 justify-content-end">
                    <span class="text-muted small" style="font-size: 0.8em"
                      >( {{ discountPercentage | number: "1.2-2" }}% )</span
                    >
                  </li>
                }

                <li>
                  <span>Total Discount Amount</span>
                  <span class="text-danger">
                    -
                    {{
                      serviceGrandTotal.discountTotal
                        | currency: "INR" : "symbol" : "1.2-2"
                    }}
                  </span>
                </li>
                <li class="border-top pt-2">
                  <span><strong>Total (Net, Before GST)</strong></span>
                  <span
                    ><strong>{{
                      serviceGrandTotal.finalTotal | number: "1.2-2"
                    }}</strong></span
                  >
                </li>
                <li>
                  <span
                    ><abbr title="Goods and Services Tax Amount"
                      >GST Total</abbr
                    ></span
                  >
                  <span>{{
                    serviceGrandTotal.gstAmount | number: "1.2-2"
                  }}</span>
                </li>
                <li class="border-top mt-2">
                  <span
                    ><strong class="fs-5 text-success"
                      >Grand Total</strong
                    ></span
                  >
                  <span
                    ><strong class="fs-5 text-success">{{
                      serviceGrandTotal.grandTotal
                        | currency: "INR" : "symbol" : "1.2-2"
                    }}</strong></span
                  >
                </li>
                <li class="border-top mt-3">
                  <div class="form-group w-100">
                    <label for="billingNotes" class="fw-semibold mb-1"
                      >Service Notes</label
                    >
                    <textarea
                      id="billingNotes"
                      [(ngModel)]="billingNotes"
                      class="form-control"
                      rows="2"
                      placeholder="Enter service notes..."
                    ></textarea>
                  </div>
                </li>
              </ul>
            </div>

            <div class="cart-btns">
              <button class="btn btnsecondary" (click)="clearServiceCart()">
                Cancel Order
              </button>
              <button class="btn btnwarning" (click)="saveServiceDraft()">
                Save as Draft
              </button>
              <button class="btn btnprimary" (click)="placeServiceOrder()">
                Place Order
              </button>
            </div>
          </div>
        } @else {
          <p class="text-center">No services added to the bill.</p>
        }
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="customerDetailsModal"
  tabindex="-1"
  aria-labelledby="customerDetailsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="customerDetailsModalLabel">
          Customer Details
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          #closeCustomerModal
        ></button>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="customerSearch" class="form-label text-dark">
                Search customers by name or phone
              </label>
              <input
                type="text"
                class="form-control"
                id="customerSearch"
                placeholder="Search customers..."
                [(ngModel)]="recipientSearchTerm"
                (input)="onRecipientSearch()"
              />
            </div>

            <div
              class="customer-list-container border rounded p-2"
              style="max-height: 400px; overflow-y: auto"
            >
              @for (customer of recipients; track customer.id) {
                <div
                  (click)="selectRecipient(customer, closeCustomerModal)"
                  [class.bg-success]="selectedCustomer?.id === customer.id"
                  [class.text-white]="selectedCustomer?.id === customer.id"
                  class="customer-item p-2 rounded border-bottom"
                  style="cursor: pointer"
                >
                  <div>
                    <strong class="text-dark">{{
                      customer.name || "N/A"
                    }}</strong>
                  </div>
                  <div class="text-muted small">
                    {{ customer.phone || "N/A" }}
                  </div>
                </div>
              }
              @if (recipients.length === 0 && !recipientsLoading) {
                <div class="text-center text-muted py-2">
                  No customers found
                </div>
              }
              @if (recipientsLoading) {
                <div class="text-center py-2 text-muted small">Loading...</div>
              }
            </div>
          </div>

          <div class="col-6">
            <div class="border-start ps-3">
              <div class="selected-customer-details mb-3">
                <h5 class="fw-bold text-dark">Selected Customer</h5>
                <p class="fw-semibold text-dark">
                  Name: {{ selectedCustomer?.name || "N/A" }}
                </p>
                <p class="fw-semibold text-dark">
                  Phone: {{ selectedCustomer?.phone || "N/A" }}
                </p>
                <p class="fw-semibold text-dark">
                  Email: {{ selectedCustomer?.email || "N/A" }}
                </p>
                <p class="fw-semibold text-dark">
                  Address: {{ selectedCustomer?.address || "N/A" }}
                </p>
              </div>

              <hr />

              <div class="create-edit-form">
                <h5 class="fw-bold text-dark">Create / Edit Customer</h5>
                <form #customerForm="ngForm">
                  <div class="mb-3">
                    <label class="form-label text-dark"
                      >Name <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="newCustomer.name"
                      name="name"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label text-dark">Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="newCustomer.phone"
                      name="phone"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label text-dark">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      [(ngModel)]="newCustomer.email"
                      name="email"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label text-dark">Address</label>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="newCustomer.address"
                      name="address"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-success"
          (click)="addNewRecipient(newCustomer); newCustomer = {}"
          data-bs-dismiss="modal"
        >
          Create New Customer
        </button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #serviceOwnerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="serviceOwnerModalLabel">
      Service Owner Details
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-6">
        <div class="mb-3">
          <label class="form-label text-dark"
            >Search Service Owners by name or email</label
          >
          <input
            type="text"
            class="form-control"
            placeholder="Search service owners..."
            [(ngModel)]="providerSearchTerm"
            (input)="onProviderSearch()"
          />
        </div>

        <div
          class="provider-list-container border rounded p-2"
          style="max-height: 400px; overflow-y: auto"
        >
          @if (providersLoading) {
            <div class="text-center py-2 text-muted small">Loading...</div>
          } @else if (providers.length) {
            @for (provider of providers; track provider.id) {
              <div
                (click)="selectProvider(provider); modal.dismiss()"
                [class.bg-success]="selectedProvider?.id === provider.id"
                [class.text-white]="selectedProvider?.id === provider.id"
                class="provider-item p-2 rounded border-bottom"
                style="cursor: pointer"
              >
                <div>
                  <strong class="text-dark">{{
                    provider.name || "N/A"
                  }}</strong>
                </div>
                <div class="text-muted small">
                  {{ provider.email || "N/A" }}
                </div>
              </div>
            }
          } @else {
            <div class="text-center text-muted py-2">
              No service owners found
            </div>
          }
        </div>
      </div>

      <div class="col-6">
        <div class="border-start ps-3">
          <h5 class="fw-bold text-dark">Create / Edit Service Owner</h5>
          <form #providerForm="ngForm">
            <div class="mb-3">
              <label class="form-label text-dark"
                >Name <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                [(ngModel)]="newProvider.name"
                name="name"
                required
              />
            </div>
            <div class="mb-3">
              <label class="form-label text-dark">Email</label>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="newProvider.email"
                name="email"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button
      type="button"
      class="btn btn-success"
      (click)="
        addNewProvider(newProvider); newProvider = {}; modal.close('Save click')
      "
    >
      Create New Service Owner
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      (click)="modal.dismiss('Cancel click')"
    >
      Close
    </button>
  </div>
</ng-template>
